module.exports = __webpack_public_path__ + "img/Logo.b095310d.svg";